/**
 * audioIndicator slice: 발언자 감지, 오디오 레벨 관리
 * wehago-conference의 redux/modules/audioIndicator 에서 리팩토링
 *
 * 주의: 기존 프로젝트의 usersCountDown[], isSpeakingTimer{} 는 모듈 레벨 변수였으므로
 * 여기서는 Redux state에 포함하지 않고 ConferenceConnector에서 관리한다.
 * Redux에는 현재 발언자 정보와 오디오 레벨만 저장한다.
 */
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface AudioIndicatorState {
  // 현재 발언 중인 사용자 ID 집합
  activeSpeakers: string[];
  // 정렬용: 최근 발언 순서 (index 0 = 가장 최근 발언자, 발언 종료 시 제거하지 않음)
  speakerOrder: string[];
  // 지배적 발언자 (Jitsi DOMINANT_SPEAKER_CHANGED)
  dominantSpeakerId: string | null;
}

const initialState: AudioIndicatorState = {
  activeSpeakers: [],
  speakerOrder: [],
  dominantSpeakerId: null,
};

const audioIndicatorSlice = createSlice({
  name: 'audioIndicator',
  initialState,
  reducers: {
    setActiveSpeaker(state, action: PayloadAction<{ userId: string; isSpeaking: boolean }>) {
      const { userId, isSpeaking } = action.payload;
      if (isSpeaking) {
        if (!state.activeSpeakers.includes(userId)) {
          state.activeSpeakers.push(userId);
        }
        // speakerOrder: 최근 발언자를 맨 앞으로 (제거 후 unshift)
        state.speakerOrder = state.speakerOrder.filter((id) => id !== userId);
        state.speakerOrder.unshift(userId);
      } else {
        state.activeSpeakers = state.activeSpeakers.filter((id) => id !== userId);
        // speakerOrder는 제거하지 않음 — 정렬 순서 유지
      }
    },

    setDominantSpeaker(state, action: PayloadAction<string | null>) {
      state.dominantSpeakerId = action.payload;
    },

    reset() {
      return initialState;
    },
  },
});

export const audioIndicatorActions = audioIndicatorSlice.actions;
export default audioIndicatorSlice.reducer;
